import { createAction, props } from "@ngrx/store";

export const setClient = createAction('setClient', props<{client: string}>())
export const showMobileMenu = createAction('showMobileMenu')
export const hideMobileMenu = createAction('hideMobileMenu')
export const showProfileMenu = createAction('showProfileMenu')
export const hideProfileMenu = createAction('hideProfileMenu')
export const toggleProfileMenu = createAction('toggleProfileMenu')